import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    ticketList: {
      requesting: false,
      items: [],
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      error: null,
      success: false,
      filters: {},
    },
    ticketDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
    ticketStatusUpdate: {
      requesting: false,
      error: null,
      success: false
    },
  };

export const ticketSlice = createSlice({
  name: 'ticket',
  initialState,
  reducers: {
    getTicketList: (state, action) => {
      state.ticketList.requesting = true;
      state.ticketList.error = null;
      state.ticketList.items = [];
      state.ticketList.success = false;
      state.ticketList.filters = action.payload;
    },
    getTicketListSuccess: (state, action) => {
      const { data, current_page, per_page, total} = action.payload;
      state.ticketList.requesting = false;        
      state.ticketList.items = data;
      state.ticketList.success = true; 
      state.ticketList.pagination.current_page = current_page;
      state.ticketList.pagination.per_page = per_page;
      state.ticketList.pagination.total = total;
    },
    getTicketListFail: (state, action) => {        
      state.ticketList.requesting = false;
      state.ticketList.error = action.payload;
    },
    getTicketDetails: (state) => {
      state.ticketDetails.requesting = true;
      state.ticketDetails.error = null;
      state.ticketDetails.data = null;
      state.ticketDetails.success = false; 
    },
    getTicketDetailsSuccess: (state, action) => {
      state.ticketDetails.requesting = false;
      state.ticketDetails.data = action.payload;
      state.ticketDetails.success = true; 
    },
    getTicketDetailsFail: (state, action) => {        
      state.ticketDetails.requesting = false;
      state.ticketDetails.error = action.payload;
    },

    doTicketCreate: (state) => {
      state.ticketDetails.requesting = true;
      state.ticketDetails.error = null;
      state.ticketDetails.data = null;
      state.ticketDetails.success = false; 
    },

    doTicketUpdate: (state) => {
      state.ticketDetails.requesting = true;
      state.ticketDetails.error = null;
      state.ticketDetails.data = null;
      state.ticketDetails.success = false; 
    },
    doTicketDelete: (state) => {
      state.ticketDetails.requesting = true;
      state.ticketDetails.error = null;
      state.ticketDetails.data = null;
      state.ticketDetails.success = false; 
    },
    updateTicketInList: (state, action) => {
      const { ticketId, updates } = action.payload;
      const index = state.ticketList.items.findIndex(
        ticket => ticket.tic_id === ticketId
      );
      if (index !== -1) {
        state.ticketList.items[index] = {
          ...state.ticketList.items[index],
          ...updates
        };
      }
    },
  },
})

export const { 
    getTicketList, getTicketListSuccess, getTicketListFail,
    getTicketDetails, getTicketDetailsSuccess, getTicketDetailsFail,
    doTicketCreate, doTicketUpdate, doTicketDelete,
    updateTicketInList,
} = ticketSlice.actions

export default ticketSlice.reducer